/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Support_Content_LabelInputs */

const en_common_support_content_label = /** @type {(inputs: Common_Support_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const zh_common_support_content_label = /** @type {(inputs: Common_Support_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`问题描述`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Common_Support_Content_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_support_content_label = /** @type {((inputs?: Common_Support_Content_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Support_Content_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_support_content_label(inputs)
	return zh_common_support_content_label(inputs)
});
export { common_support_content_label as "common.support.content_label" }